import { useTranslations } from 'next-intl'

import {
  AdditionalOption,
  OldAdditionalOption,
  TRoomDetail,
} from '@/entities/room'
import { cn } from '@/shared/lib'
import { TextButton } from '@/shared/ui'

import { OptionDialogTrigger } from './option-dialog'
import { OptionList } from './option-list'
import { getOptionData } from '../../../lib/option'
import { Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'basicOptions' | 'missingOptions'> & {
  additionalOptions: (AdditionalOption | OldAdditionalOption)[]
}

export const RoomOption = ({
  basicOptions,
  additionalOptions,
  missingOptions,
}: Props) => {
  const t = useTranslations('room_detail')

  const { slicedOptions, totalCount, hasBasicOptions, hasAdditionalOptions } =
    getOptionData({ basicOptions, additionalOptions })

  return (
    <section className="space-y-4">
      {hasBasicOptions && (
        <div className={cn('space-y-4', hasAdditionalOptions && 'mb-20')}>
          <Heading>{t('basic_option.title')}</Heading>
          <OptionList options={basicOptions} />
        </div>
      )}

      {hasAdditionalOptions && (
        <div className="space-y-4">
          <Heading>{t('additional_option.title')}</Heading>
          <OptionList options={slicedOptions} />
        </div>
      )}

      <OptionDialogTrigger
        basicOptions={basicOptions}
        additionalOptions={additionalOptions}
        missingOptions={missingOptions}
      >
        <TextButton size="small" underline color="black" weight="normal">
          {t('option.button.view_all', { count: totalCount })}
        </TextButton>
      </OptionDialogTrigger>
    </section>
  )
}
